import { Activity } from 'app/modules/activity/models/activity/activity.model';
import { HttpParams } from '@angular/common/http';

export class GetStreamActivityTypes {
  static readonly type = '[ActivityStream] GetStreamActivityTypes';
  constructor(
    public params: HttpParams,
  ) {}
}

export class GetLatestActivities {
  static readonly type = '[Activity] GetLatestActivities';
  constructor(public criteria: {
    types: [];
    start: undefined;
    end: undefined;
    reset: boolean;
  }) {}
}

export class GetStreamActivities {
  static readonly type = '[ActivityStream] GetStreamActivities';
  constructor(
    public criteria: any,
    public limit: number,
    public offset: number,
    public reset?: boolean,
  ) {}
}

export class ActivityStreamEvent {
  static readonly type = '[ActivityStream] ActivityStreamEvent';
  constructor(
    public activity: Activity,
  ) {}
}

export class GetMoreActivities {
  static readonly type = '[Activity] GetMoreActivities';
  constructor(public criteria: {}) {}
}

export class LatestActivitiesViewed {
  static readonly type = '[Activity] LatestActivitiesViewed';
  constructor () {}
}

export class GetLenderUserActivities {
  static readonly type  = '[Activity] GetLenderUserActivities';
  constructor(public lenderUserId: number, public queryFilters: string[],
    public paginationPage: number = 1) {}
}

export class ActivitiesNextPage {
	static readonly type = '[Activity] ActivitiesNextPage';
	constructor(public criteria: {}) {}
}

export class ClearActivityStreamStore {
	static readonly type = '[Activity] ClearActivityStreamStore';
	constructor() {}
}

export class RemoveActivityById {
  static readonly type = '[Activity] RemoveActivityById';
  constructor(public activityId: number) {}
}
